export default {
      id: "cart-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#cart",
      toString: function () {
        return this.url;
      }
    }